import request from '@/utils/request'

const userIntegralDetails = {
  name: 'userIntegralDetails',
  state: {
    isUserIntegralDetailsDetailLoading: false,
    userIntegralDetailsDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_USERINTEGRALDETAILS_DETAIL_LOADING: (state, data) => {
      state.isUserIntegralDetailsDetailLoading = data
    },
    SET_MODULES_USERINTEGRALDETAILS_DETAIL_DATA: (state, data) => {
      state.userIntegralDetailsDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryUserIntegralDetailsDetailData({ commit }, id) {
      commit('SET_IS_MODULES_USERINTEGRALDETAILS_DETAIL_LOADING', true)
      commit('SET_MODULES_USERINTEGRALDETAILS_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userIntegralDetails/userIntegralDetailsDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_USERINTEGRALDETAILS_DETAIL_LOADING', false)
          commit('SET_MODULES_USERINTEGRALDETAILS_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_USERINTEGRALDETAILS_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetUserIntegralDetailsDetailData({ commit }) {
      commit('SET_MODULES_USERINTEGRALDETAILS_DETAIL_DATA', {})
    },
    //  重置账号新增页面数据
    setUserIntegralDetailsDetailData({ commit }, data) {
      commit('SET_MODULES_USERINTEGRALDETAILS_DETAIL_DATA', data)
    }
  }
}

export default userIntegralDetails
